import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const ratingApi = {
	...createCrudHooks({
		baseKey: "ratings",
		basePath: "/ratings",
		getParams: {},
	}),

	useSet() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ rateableType, rateableId, field, value }) => {
				api.post(`/ratings/${rateableType}/${rateableId}/${field}/${value}`)
				.then(r => {
					qc.invalidateQueries([rateableType + 's', rateableId]);
					qc.invalidateQueries([rateableType + 's']);
					return r;
				})
				.then(r => processResult(qc, r))},
		});
	},
};
